const resetState = () => ({
    navMenus:[
      {
        url: '/home',
        name: 'Home',
      },
      {
        url: '/feature',
        name: 'Featured Rentals',
      },
      {
        url: '/property-manager-about',
        name: 'Property Managers',
      },
      {
        url: '/owner-details',
        name: 'Owners',
      },
      {
        url: '/residents',
        name: 'Residents',
      },
      {
        url: '/recommend',
        name: 'Recommend',
      },
      {
        url: '/pricing',
        name: 'Pricing',
      },
      {
        url: '/contact',
        name: 'Contact Us',
      },
    ],
    logo:require('~/assets/img/logo 11.png'),
    homeUrl:'/home',
    showManagementLogin:false,
    isMobileMenuOpen: false,
})
const mutations = {
  setMobileHeader(state, val) {
    state.navMenus = val.navMenus
    state.logo = val.logo
    state.homeUrl = val.homeUrl
    state.showManagementLogin = val.showManagementLogin
  },
  setMobileMenuClick(state, isMobileMenuOpen) {
    state.isMobileMenuOpen = isMobileMenuOpen
    console.log(state)
  },
  setMobileMenus(state, nav) {
    state.navMenus = nav
  },
  setMobileMenuLogo(state, logo) {
    state.logo = logo
  },
  setMobileMenuHomeUrl(state, homeUrl) {
    state.homeUrl = homeUrl
  },
  setMobileMenuManagementLoginBtn(state, showManagementLogin) {
    state.showManagementLogin = showManagementLogin
  },
  resetState(state) {
    Object.assign(state,resetState());
  },

}
export default mutations
